import { isPlainObject } from 'es-toolkit/compat';
export default isPlainObject;
